export default __webpack_public_path__ + "static/media/640_dummy2016-baeckerei01-mobile-de.cf8e8b69.png";